/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrCreateSavingsBalance} from '../api'

 export const useQueryGetOrCreateSavingsBalance = createReactQueryHook('getOrCreateSavingsBalance', getOrCreateSavingsBalance)
